import { useCallback, useMemo } from 'react';

import { Spin, Table } from 'antd';
import classNames from 'classnames';

import { useIsMobile } from 'packages/utils';

import styles from './tableRenderer.module.less';

const TABLE_SCROLL = { x: 'max-content' };

const DashboardTableContent = ({ data, loading }) => {
  const { isMobile } = useIsMobile();

  const {
    metrics = [],
    columns = [],
    totalEvents = 0,
    currentPage = 1,
    pageSize = 10,
    handlePageChange = () => {},
    onTableChange,
  } = data || {};

  const handleChange = useCallback(
    (pagination, filters, _sorter, extra) => {
      onTableChange?.(pagination, filters);
      if (extra?.action === 'paginate') {
        handlePageChange(pagination?.current, pagination?.pageSize);
      }
    },
    [onTableChange, handlePageChange],
  );

  const paginationConfig = useMemo(
    () => ({
      current: currentPage,
      pageSize,
      total: totalEvents,
      size: isMobile ? 'small' : undefined,
      position: ['bottomCenter'],
      showSizeChanger: false,
    }),
    [currentPage, pageSize, totalEvents, isMobile],
  );

  if (!data?.metrics) {
    return <Spin spinning={loading} />;
  }

  return (
    <Spin spinning={loading}>
      <div className={classNames('cancelDrag', styles.tableWrapper)}>
        <div className="gx-table-responsive">
          <Table
            className={classNames('gx-table-no-bordered', styles.table)}
            size="small"
            bordered={false}
            dataSource={metrics}
            columns={columns}
            onChange={handleChange}
            pagination={paginationConfig}
            scroll={TABLE_SCROLL}
          />
        </div>
      </div>
    </Spin>
  );
};

export const renderTableContent = ({ data, loading }) => (
  <DashboardTableContent data={data} loading={loading} />
);
